import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BasicForm } from '@components/basic'
import { IBasicForm } from '@/const/types/form'
import { email, minLength, required } from '@vuelidate/validators'
import useScanner from '@/composable/useScanner';
import { useToast } from 'vue-toastification';

interface Props {
  isLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginFormUser',
  props: {
    isLoading: { type: Boolean, default: false }
  },
  emits: ["onSubmit"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onSubmit', inputsValues: object): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLoading: boolean };





const toast = useToast()

const schema: IBasicForm = {
    name: 'Get the correct domain for all wms requests.',
    inputs: [
        {
            name: 'email',
            label: 'Email',
            type: 'basic',
            validation: { required, email },
            props: {
                type: 'email',
            },
        },
        {
            name: 'password',
            label: 'Password',
            type: 'basic',
            validation: { required, minLength: minLength(6) },
            props: {
                type: 'password',
            },
        },
        {
            name: 'remember_me',
            label: 'Remember me',
            type: 'checkbox',
        },
    ],
    handlers: {
        onSuccess(inputsValues) {
            emit('onSubmit', inputsValues);
        }
    },
}

const handleLoginOnScan = (input: string) => {
    try {
        const values = input.trim().split(" : ")
        if (values.length == 2) {
            emit('onSubmit', { remember_me: false, email: values[0], password: values[1] })
        } else if (values.length == 3) {
            const remember_me = (values[0] == "1" ? true : false);
            emit('onSubmit', { remember_me, email: values[1], password: values[2] })
        } else {
            throw Error()
        }
    } catch {
        toast.error("Incorrect input.")
    }
}

useScanner({ onScan(input) { handleLoginOnScan(input) } })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BasicForm), {
    schema: schema,
    "is-loading": props.isLoading
  }, null, 8, ["is-loading"]))
}
}

})